(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function loadWhenReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function initReadMore() {
    document.querySelectorAll('[data-gf-readmore]').forEach(function (el) {
      var toggle = el.querySelector('[data-gf-readmore-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var isOpen = el.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        toggle.textContent = isOpen ? 'Read less' : 'Read more';
      });
    });
  }

  function initMediaLoaded() {
    document.querySelectorAll('[data-gf-media-slug] .gf-media__img--auto').forEach(function (img) {
      var figure = img.closest('[data-gf-media-slug]');
      if (!figure) return;
      function markLoaded() { figure.classList.add('gf-media--loaded'); }
      if (img.complete && img.naturalWidth > 0) markLoaded();
      else {
        img.addEventListener('load', markLoaded);
        img.addEventListener('error', function () { figure.classList.remove('gf-media--loaded'); });
      }
    });
  }

  function initStickyCart() {
    var bar = document.querySelector('[data-gf-sticky-cart]');
    var buy = document.querySelector('[data-gf-product-buy]');
    if (!bar || !buy) return;

    var observer = new IntersectionObserver(
      function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      },
      { threshold: 0, rootMargin: '0px 0px -80px 0px' }
    );
    observer.observe(buy);
  }

  /** Wrap text nodes in [data-gf-split-chars] for CSS letter stagger (hero only). */
  function initSplitChars() {
    if (prefersReduced) return;

    document.querySelectorAll('[data-gf-split-chars]').forEach(function (el) {
      if (el.dataset.gfSplitDone === '1') return;
      var text = el.textContent;
      if (!text || text.length > 48) return;

      el.setAttribute('aria-label', text.trim());
      el.textContent = '';
      var delayBase = el.classList.contains('gf-hero__title-line--red') ? 0.22
        : el.classList.contains('gf-hero__title-line--white') ? 0.1
        : 0.04;
      var i = 0;

      text.split(/(\s+)/).forEach(function (chunk) {
        if (/^\s+$/.test(chunk)) {
          el.appendChild(document.createTextNode(chunk));
          return;
        }
        var word = document.createElement('span');
        word.className = 'gf-word';
        word.setAttribute('aria-hidden', 'true');
        Array.from(chunk).forEach(function (ch) {
          var span = document.createElement('span');
          span.className = 'gf-char';
          span.textContent = ch;
          span.style.animationDelay = (delayBase + i * 0.028) + 's';
          word.appendChild(span);
          i += 1;
        });
        el.appendChild(word);
      });

      el.dataset.gfSplitDone = '1';
    });
  }

  /** Count-up for [data-gf-count] when the results strip enters view. */
  function initCountUp() {
    var nodes = document.querySelectorAll('[data-gf-count]');
    if (!nodes.length) return;

    function parseTarget(raw) {
      var m = String(raw).trim().match(/^(\d+(?:\.\d+)?)(.*)$/);
      if (!m) return null;
      return { num: parseFloat(m[1], 10), suffix: m[2] || '' };
    }

    function animate(el, target) {
      if (prefersReduced) {
        el.textContent = target.num + target.suffix;
        return;
      }
      var duration = 900;
      var start = performance.now();
      var from = 0;
      var isInt = Number.isInteger(target.num);

      function frame(now) {
        var t = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        var val = from + (target.num - from) * eased;
        el.textContent = (isInt ? Math.round(val) : val.toFixed(1)) + target.suffix;
        if (t < 1) requestAnimationFrame(frame);
        else el.textContent = target.num + target.suffix;
      }
      requestAnimationFrame(frame);
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var parsed = parseTarget(el.getAttribute('data-gf-count') || el.textContent);
        if (parsed) animate(el, parsed);
        observer.unobserve(el);
      });
    }, { threshold: 0.4 });

    nodes.forEach(function (el) { observer.observe(el); });
  }

  loadWhenReady(function () {
    initReadMore();
    initMediaLoaded();
    initStickyCart();
    initSplitChars();
    initCountUp();
  });
})();
